import React, { Component } from "react";

class Select extends Component {
  // selection of options
  getOptions() {
    const options = this.props.options;
    // get all the options that passed in
    const optionsComponent = options.reduce((acc, curr, index) => {
      const component = (
        <option key={index} value={curr}>
          {curr}
        </option>);

      acc.push(component);
      return acc;
    }, []);

    return optionsComponent;
  }

  render() {
    return (
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <span
            className="input-group-text font-weight-bold"
            id="inputGroup-sizing-default"
          >
            {this.props.textName}
          </span>
        </div>
        <select value={this.props.value} className="custom-select" onChange={(input) => this.props.onChange(input.target.value)}>
          {this.getOptions()}
        </select>
      </div>
    );
  }
}
export default Select;


// WEBPACK FOOTER //
// ./src/components/select/index.js